import React from "react";
import RightSidebar from "../../../sidebar/RightSideBar";
import { getPlatformIcon, getPlatformStyle } from "../../../ui/SocialMediaIcons";

const MemberProfileSidebar = ({ 
  isOpen, 
  onClose, 
  member 
}) => {
  if (!member) return null;

  // Basic safety check for HTML content
  const sanitizeHtml = (html) => {
    if (!html) return "";
    // Remove script tags and their content
    return html.replace(/<script\b[^>]*>([\s\S]*?)<\/script>/gim, "");
  };
  

  return (
    <RightSidebar
      isOpen={isOpen}
      onClose={onClose}
      title="Member Profile"
    >
      <div className="flex flex-col h-full text-slate-900">

        {/* Header / Avatar Section */}
        <div className="flex flex-col items-center text-center pb-8 border-b border-slate-100">
          <div className="w-32 h-32 rounded-3xl bg-indigo-50 border-4 border-white shadow-xl overflow-hidden mb-6 relative group">
            {member.profile_image ? (
              <img
                src={member.profile_image}
                alt={member.first_name}
                className="w-full h-full object-cover"
              />
            ) : (
              <div className="w-full h-full flex items-center justify-center text-3xl font-bold text-slate-300">
                {member.first_name?.[0]}{member.last_name?.[0]}
              </div>
            )}
          </div>
          <h2 className="text-2xl font-black text-slate-900 tracking-tight">
            {member.first_name} {member.last_name}
          </h2>
          <p className="text-indigo-600 font-bold uppercase tracking-widest text-[10px] mt-1 bg-indigo-50 px-3 py-1 rounded-full">
            {member.designation || "Exhibitor Team"}
          </p>
        {member.social_links?.length > 0 && (
          <div className="flex items-center justify-between gap-1 px-4 pt-2">
            {member.social_links.map((link, i) => {
              const style = getPlatformStyle(link.platform);
              return (
                <a
                  key={i}
                  href={link.url}
                  target="_blank"
                  rel="noreferrer"
                  title={link.platform}
                  style={{ backgroundColor: style.bg, color: style.color }}
                  className="w-8 h-8 rounded-full flex items-center justify-center
                  transition-opacity hover:opacity-80 shrink-0 shadow-sm"
                >
                  {getPlatformIcon(link.platform)}
                </a>
              );
            })}
          </div>
        )}
        </div>

        {/* Social Links Row */}
        {/* About Section */}
        {member.about && (
          <div className="py-8">
            <h3 className="text-slate-400 font-bold uppercase tracking-widest text-[10px] mb-4">
              About
            </h3>
            <div 
              className="prose prose-slate prose-sm max-w-none text-slate-600 font-medium leading-relaxed"
              dangerouslySetInnerHTML={{ __html: sanitizeHtml(member.about) }}
            />
          </div>
        )}
      </div>
    </RightSidebar>
  );
};

export default MemberProfileSidebar;
